module.exports = __webpack_public_path__ + "img/icon-advantage@3x1.245694b4.png";